export default __webpack_public_path__ + "static/media/807.69fa1d74.gif";